import { ConfigProvider, Radio } from 'antd';
import React, { forwardRef } from 'react';
import Label from './Label';
import HelperText from './HelperText';

type Props = {
  label?: string;
  helperText?: string;
  id: string;
  required?: boolean;
  status?: 'error' | 'success';
  labelHelperText?: string;
  labelClassName?: string;
} & React.ComponentProps<typeof Radio.Group>;

const CustomRadio = forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      helperText,
      id,
      required,
      labelHelperText,
      status,
      labelClassName,
      ...props
    }: Props,
    ref
  ) => {
    return (
      <div className="flex flex-col">
        {label && (
          <Label
            labelHelperText={labelHelperText}
            required={required}
            text={label}
            className={labelClassName}
          />
        )}
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#FD9FFD',
              colorBorder: status === 'error' ? '#cc2936' : '',
            },
          }}
        >
          <Radio.Group
            className="dark:!text-white"
            id={id}
            {...props}
            ref={ref}
          />
        </ConfigProvider>
        {helperText && <HelperText text={helperText} status={status} />}
      </div>
    );
  }
);

CustomRadio.displayName = 'CustomRadio';

export default CustomRadio;
